module.exports = __webpack_public_path__ + "img/wrcsfw-cyys.a650d2ff.png";